<template>
  <div class="local-file-picker">
    <el-button
      :icon="buttonIcon"
      :type="buttonType"
      :disabled="disabled"
      @click="openFileDialog"
    >
      {{ buttonText }}
    </el-button>
    <input
      ref="fileInput"
      type="file"
      :accept="accept"
      :multiple="multiple"
      style="display: none"
      @change="handleFileChange"
    >
  </div>
</template>

<script>
export default {
  name: 'LocalFilePicker',
  props: {
    accept: {
      type: String,
      default: '*/*'
    },
    multiple: {
      type: Boolean,
      default: false
    },
    buttonText: {
      type: String,
      default: '选择文件'
    },
    buttonType: {
      type: String,
      default: 'primary'
    },
    buttonIcon: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    openFileDialog() {
      if (this.disabled) return
      this.$refs.fileInput.click()
    },
    handleFileChange(e) {
      const files = Array.from(e.target.files || [])
      this.$emit('change', files, e)
      // 允许重复选择同一个文件
      e.target.value = ''
    }
  }
}
</script>

<style scoped>
.local-file-picker {
  display: inline-block;
}
</style>
